import logo from "../../customs.png";
import { generateYears } from "../options";

const jp_strings = {
  options: {
    russiaCities: [
      "モスクワ",
      "ハバロフスク",
      "ユジノサハリンスク",
      "イルクーツク",
      "ウラジオストク",
      "その他",
    ],
    taiwanCities: ["台北", "台中", "桃園市", "新竹市", "高雄市", "その他"],
    chinaCities: [
      "上海",
      "北京",
      "広州市",
      "杭州市",
      "大連市",
      "南京市",
      "ハルビン市",
      "鄭州市",
      "瀋陽市",
      "成都市",
      "その他",
    ],
    koreaCities: [
      "ソウル",
      "プサン",
      "インチョン/キョンギド",
      "デグ",
      "テジョン",
      "クァンジュ",
      "ウルサン",
      "その他",
    ],
    japanCities: [
      "関東",
      "近畿",
      "中部",
      "北海道",
      "東北",
      "甲信越",
      "北陸",
      "中国",
      "四国",
      "九州",
      "沖縄",
      "その他",
    ],
    guamStatus: [
      "乗り継ぎ",
      "搭乗員ー終着",
      "搭乗員ー乗り継ぎ",
      "  帰国するグアム居住者",
    ],
    status: [
      "訪問者",
      "乗り継ぎ",
      "搭乗員ー終着",
      "搭乗員ー乗り継ぎ",
      "１年以上居住予定の移住者",
      "帰国するグアム居住者",
    ],
    country: [
      "グアム",
      "アメリカ合衆国",
      "日本",
      "韓国",
      "中国",
      "台湾",
      "オーストラリア",
      "北マリアナ諸島",
      "ヨーロッパ",
      "ミクロネシア連邦",
      "香港",
      "インド",
      "マレーシア",
      "パラオ",
      "フィリピン",
      "マーシャル諸島",
      "シンガポール",
      "ロシア",
      "その他",
    ],
    year: generateYears(),
    month: [
      "1月",
      "2月",
      "3月",
      "4月",
      "5月",
      "6月",
      "7月",
      "8月",
      "9月",
      "10月",
      "11月",
      "12月",
    ],
    day: [
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "10",
      "11",
      "12",
      "13",
      "14",
      "15",
      "16",
      "17",
      "18",
      "19",
      "20",
      "21",
      "22",
      "23",
      "24",
      "25",
      "26",
      "27",
      "28",
      "29",
      "30",
      "31",
    ],
    reason: [
      "観光/休暇",
      "結婚式",
      "新婚旅行",
      "会議/コンファレンス",
      "報奨旅行/慰安旅行",
      "その他のビジネス関係",
      "友人/親戚への訪問",
      "政府または軍事関係者",
      "修学旅行",
      "スポーツイベント",
      "医療関係",
      "その他のビジネス関係",
    ],
    length: [
      "数時間のみ",
      "日帰り旅行",
      "1泊",
      "2泊",
      "3泊",
      "4泊",
      "5泊",
      "6泊",
      "7-10泊",
      "11-15泊",
      "16-30泊",
      "1-3ヶ月",
      "3ヶ月-1年",
    ],
    trip: ["初めて", "2度目", "3度目", "4度目", "5度目", "6度もしくはそれ以上"],
    arrangement: [
      "旅行代理店",
      "オンライン旅行サイト",
      "ホテル/航空会社など直接予約を行なった",
    ],
    stay: [
      "ホテル",
      "バケーションレンタル（貸別荘)",
      "クルーズ船",
      "知人または親戚宅",
      "朝食付き宿泊施設（B＆B）",
      "軍事施設",
      "タイムシェア",
      "その他",
    ],
  },
  DD: "日",
  MM: "月",
  YYYY: "西暦",
  dob: "生年月日",
  heading: `![logo](${logo})\n\n# 電子税関申告書\n\n## 電子申告書\n\n`,
  healthFormDescription:
    "## 健康申告書\n\n## すべての入国者は、健康申告書を提出する必要があります。（１人につき１申請）",
  intendedResidentDescription: "# Iグアムへの移住者",
  nameFieldLabel: "氏名",
  firstNameLabel: "名",
  middleNameLabel: "ミドルネーム",
  lastNameLabel: "姓",
  packingListTitleLabel:
    "## 申告する物品\n\nWARNING: 警告：規制/禁止品目をグアムへ持ち込むことは、第一級の重罪に相当します。(Title 9 GCA, Section 67)。この法律に対する違反行為は、懲役10年以下の強制的な実刑判決の対象となります。税関検査員に対して虚偽の陳述を行なった場合は、法律によって罰せられる場合があります。税関では、すべての荷物、手提げかばん、手荷物が開封および検査の対象となる可能性があります。報告または申告すべき物品についてご質問をお持ちの場合は、税関検査員にお尋ねください。グアムの自然に害を及ぼす可能性がある農業害虫や禁止されている野生動物の上陸を防ぐため、果実、野菜、植物、植物製品、土壌、肉類、肉製品、鳥、巻貝、その他の生きた動物または動物性食品等の持ち込みには規制が設けられています。上記品目の申告を怠った場合は、罰金および品目の没収措置が適用される場合があります。グアム内国歳入法では、海外で入手した物品および商品は、使用済みであるかどうか、課税対象の物品であるかどうか、自分で購入したものか贈答品かを問わず、すべて申告することが義務付けられています。すべての物品や商品を列記してください。",
  bringingLabel: "グアムに持参しています。",
  substancesLabel: "規制薬物（処方箋あり/なし）",
  firearmsLabel: "個人所有の銃器、武器",
  explosivesLabel: "爆発物（商用または消費者向け花火を含む）",
  animalsLabel: "動物、動物の一部または野生動物から製造された物品",
  animalProductsLabel: "肉、牛乳、卵などの動物性食品",
  plantsLabel:
    "生果、野菜、花、植物素材で製造された物品を含む植物またはその一部",
  soilLabel: "土壌物質、土壌標本、生物学的標本",
  serviceAnimalLabel: "介助動物（盲導犬など)",
  cigarettesLabel:
    "５カートン/１０００本を超えるたばこまたは１２個以上のたばこ製品",
  alcoholLabel: "大人ひとり当たり１ガロン/３．７リットルを超えるアルコール飲料",
  welcomeText:
    "### ハファディ！グアムへようこそ\n 皆様の安全のため、グアムに到着する全ての人に電子税関申告書の提出をお願いしています。到着前に下記をお読みいただき、入力してください。米国およびグアムの法律に準拠していることをご確認ください。虚偽の申請を行うと法律にて罰せられます。\n\n 到着日の７２時間前から申請することが可能です。",
  welcomeButtonText: "申告書に回答する準備ができました",
  visitorSpecificDescriptionLabel: "# 来島情報",
  onlineBookingLabel: "オンラインで旅行の予約をしましたか？",
  genderLabel: "性別",
  emailLabel: "メールアドレス",
  TelephoneNumber: "電話番号",
  NationalityLabel: "国籍",
  WorkplaceLabel: "職場",
  OccupationLabel: "職業",
  SymptomsLabel: "現在または過去14日間に以下の症状があります/ありましたか？",
  FeverLabel: "発熱",
  Headache: "頭痛",
  Cough: "咳",
  SoreThroat: "咽喉炎、咽頭痛",
  BodyWeakness: "脱力感",
  JointMusclePain: "関節痛/筋肉痛",
  BruisingBleeding: "打撲/出血",
  Rashes: "発疹/じんましん",
  RedEyes: "目の充血",
  Nausea: "吐き気/むかつき",
  Vomiting: "嘔吐",
  Diarrhea: "下痢",
  DifficultybreathingShortnessofbreath: "呼吸困難/息切れ",
  Other: "その他",
  healthWorkerLabel: "医療従事者、病院、診療所、介護施設を訪問しましたか？",
  poultryFarmLabel:
    "養鶏場やアニマルマーケット（動物を売買する市場）に行きましたか？",
  contactRespiratoryLabel:
    "あなた、またはあなたの家族が発熱、咳および呼吸器系の疾患を抱えている人と濃厚接触しましたか？",
  sickFamilyGroupLabel: "家族またはグループ内に病気の人がいますか？",
  recentMedicationLabel: "４−６時間以内に服用した薬はありますか？",
  dphssText:
    "グアム公衆衛生保健局の使命は、島に最大のリスクをもたらす健康関連の脅威からグアムを保護することです。公衆衛生上の非常事態の宣言下、保健局担当者は過去の旅行歴を健康情報に関する質問をする権利を有します。\n\n 虚偽の申告は法律により罰せられます。\n\n 私は、グアムの法律に基づく偽証罪の罰則のもとで、本申告書に記載された要件を読み、理解しました。私が作成した本申告書によるすべての陳述が事実と相違ないことを宣言します。",
  promoLabel: "グアム政府観光局からプロモーション情報を受け取りたい場合は、",
  descriptionLabel:
    "# 個人情報\n すべての入国者（または家族の代表者）は以下の情報を英語でご記入ください。（１家族につき１申請です。「家族」とは、血縁、結婚、同棲または養子縁組により同世帯に住む人と定義されます。）",
  todaysDateLabel: "グアム到着日",
  crewLabel: "Crew",
  airlineLabel: "航空会社/船舶会社",
  flightLabel: "航空機便名/船名",
  flightCityLabel: "国籍/市",
  countryLabel: "国籍",
  originatingCountryLabel: "出発国",
  originatingCityLabel: "出発地（都道府県、市区町村）",
  familyMembersLabel: "自分を含む家族の人数",
  passportCountryLabel: "発行国",
  passportNoLabel: "パスポート番号またはトラベルID",
  placeOfResidenceLabel: "居住地（国/都道府県）",
  arrivalInformationLabel: "## 到着情報",
  addressOnGuamLabel: "グアムでの滞在先住所/ホテル名",
  statusLabel: "旅の目的",
  transitFormDescription: "# Transiting",
  residentFormDescription: "# Returning Resident",
  returningReasonLabel: "グアム旅行の主な目的",
  transitingDestination: "最終目的地",
  resaleTitle: "# 商用目的の物品",
  currencyVisitorCrewTitle: "# 通貨もしくは通貨代替物",
  over10kLabel:
    "US＄10,000を超える額の通貨代替物または相当額の外貨を持ち込みますか？",
  resaleLabel: "商用目的の物品を持ち込みますか？",
  remainLabel:
    "グアム居住者 – 国外で入手し、グアムに持ち込もうとするすべての物品（贈答品、商用目的の物品を含む）の合計金額",
  declarationDescription:
    "# 申告する物品\nグアムの税関および検疫局 (Guam Customs and Quarantine Agency) は、禁止/規制された品目の不法輸入を防ぐ責任を負っています。税関検査員は、入国者に対して質問および所持品の検査を行う権限を有しています。検査員は、検査の対象に選ばれた入国者に対して礼儀正しく、かつ職務遂行のため毅然とした態度で接します。何かご質問があれば、担当の税関検査員または監督官（スーパーバイザー）がお答えします。\n\n警告：規制/禁止品目をグアムへ持ち込むことは、第一級の重罪に相当します。(Title 9 GCA, Section 67)。この法律に対する違反行為は、懲役10年以下の強制的な実刑判決の対象となります。税関検査員に対して虚偽の陳述を行なった場合は、法律によって罰せられる場合があります。税関では、すべての荷物、手提げかばん、手荷物が開封および検査の対象となる可能性があります。報告または申告すべき物品についてご質問をお持ちの場合は、税関検査員にお尋ねください。グアムの自然に害を及ぼす可能性がある農業害虫や禁止されている野生動物の上陸を防ぐため、果実、野菜、植物、植物製品、土壌、肉類、肉製品、鳥、巻貝、その他の生きた動物または動物性食品等の持ち込みには規制が設けられています。上記品目の申告を怠った場合は、罰金および品目の没収措置が適用される場合があります。グアム内国歳入法では、海外で入手した物品および商品は、使用済みであるかどうか、課税対象の物品であるかどうか、自分で購入したものか贈答品かを問わず、すべて申告することが義務付けられています。すべての物品や商品を列記してください。",
  declarationPreviousLabel: "前のページで下記物品に”はい”と申告した",
  declarationDescriptionLabel: "申告する物品その他追加物品を記入してください。",
  consentDescriptionLabel:
    "## Certification Statement\n\nグアムの税関および検疫局 (Guam Customs and Quarantine Agency) は、禁止/規制された品目の不法輸入を防ぐ責任を負っています。税関検査員は、入国者に対して質問および所持品の検査を行う権限を有しています。検査員は、検査の対象に選ばれた入国者に対して礼儀正しく、かつ職務遂行のため毅然とした態度で接します。何かご質問があれば、担当の税関検査員または監督官（スーパーバイザー）がお答えします。",
  consentCertifyFieldLabel:
    "私は、本申告書に記載された要件を読み、理解しています。私が口頭または書面により行なった申告の内容はすべて事実と相違ありません。",
  Yes: "はい",
  No: "いいえ",
  lengthOfStayLabel: "滞在期間",
  tripDescription: "グアム訪問は何回目ですか？",
  arrangementsLabel: "旅行の予約はどのようにしましたか？",
  placeOfStayLabel: "グアムでの滞在先はどちらですか？（当てはまるもの全て）",
  nextLabel: "次に進む",
  prevLabel: "前に戻る",
  resetLabel: "リセット",
  AdditionalLabelText: "## 追加家族の人数",
  FullNameText: "氏名",
  tripReasonLabelText: "旅行の主な目的は？",
  EmailCollectionText:
    "今後のイベントやプロモーションについてグアム政府観光局からのご案内を希望する場合は、電話番号またはメールアドレスを入力してください。",
  PhoneFieldLabel: "携帯番号",
  EveryFieldLabel: "以下の物品を持ち込みますか？",
  DeclarationNALabel:
    "列記された物品のグアムへの持ち込みに関してあたなはいずれも持ち込まないと答えました。それ以外に何か申告する物品はありますか。",
  GoodsDescriptionLabel: "申告する物品:",
  YesOrNoLabel: "はいかいいえでお答えください",
  EnterValueLabel: "合計金額を入力してください",
  ResidentsTotalValueLabel:
    "グアム居住者 – 国外で入手し、グアムに持ち込もうとするすべての物品（贈答品、商用目的の物品を含む）の合計金額",
  SeatNumberLabel: "座席番号",
  CountriesVisitedLabel:
    "過去14日間で、滞在または乗り継ぎした全ての国を選択してください。",
  ChinaVisitedLabel: "中国",
  IranVisitedLabel: "イラン",
  ItalyVisitedLabel: "イタリア",
  SouthKoreaVisitedLabel: "韓国",
  JapanVisitedLabel: "日本",
  HongKongVisitedLabel: "香港",
  MacaoSARVisitedLabel: "マカオ",
  VietnamVisitedLabel: "ベトナム",
  ThailandVisitedLabel: "タイ",
  PhilippinesVisitedLabel: "フィリピン",
  MalaysiaVisitedLabel: "マレーシア",
  TaiwanVisitedLabel: "台湾",
  CambodiaVisitedLabel: "カンボジア",
  SingaporeVisitedLabel: "シンガポール",
  NewZealandVisitedLabel: "ニュージーランド",
  AustraliaVisitedLabel: "オーストラリア",
  CanadaVisitedLabel: "カナダ",
  AmericanSamoaVisitedLabel: "アメリカ領サモア",
  MarshallIslandsVisitedLabel: "マーシャル諸島",
  FSMVisitedLabel: "ミクロネシア連邦",
  CNMIVisitedLabel: "北マリアナ諸島",
  PalauVisitedLabel: "パラオ",
  USVisitedLabel: "米国（場所を明記）",
  OtherVisitedLabel: "その他　（国を明記）",
  FeverAdviceText:
    "該当する場合のみ入力してください。過去14日間発熱症状がなければ空欄にしてください。）",
  Person2: "### 2人目",
  Person3: "### 3人目",
  Person4: "### 4人目",
  Person5: "### 5人目",
  Person6: "### 6人目",
  Person7: "### 7人目",
  Person8: "### 8人目",
  City: "市",
  required: "必要です。",
  acceptError: "🚫 同意して次へ進む。",
  Male: "男",
  Female: "女",
  QRCode: "QRコード",
  presentCode:
    "電子税関申告書を作成いただきありがとうございます。あなたのQRコードを印刷/保存し、税関検査官に提示してください。",
  finish: "終了",
  thankYou: "シジュウス　マアセ（チャモロ語でありがとう）",
  seeYouSoon: "皆様にお会いできるのを楽しみにしています！",
  languages: {
    selectLanguage: "言語を選択する",
    languagePrompt:
      "グアムEDFは複数の言語で提供されています。最も便利な言語を選択してください",
    en: "英語 (English)",
    jp: "日本語",
    kr: "韓国語 (한국어)",
    cn: "繁体字中国語 (繁體中文)",
  },
  countries: {
    AF: "アフガニスタン",
    AX: "オーランド諸島",
    AL: "アルバニア",
    DZ: "アルジェリア",
    AS: "アメリカンサモア",
    AD: "アンドラ",
    AO: "アンゴラ",
    AI: "アンドラ",
    AQ: "南極大陸",
    AG: "アンティグアバブーダー",
    AR: "アルゼンチン",
    AM: "アルメニア",
    AW: "アルバ",
    AU: "オーストラリア",
    AT: "オーストリア",
    AZ: "アゼルバイジャン",
    BS: "バハマ",
    BH: "バーレーン",
    BD: "バングラデシュ",
    BB: "バルバドス",
    BY: "ベラルーシ",
    BE: "ベルギー",
    BZ: "ベリーズ",
    BJ: "ベナン",
    BM: "バミューダ",
    BT: "ブータン",
    BO: "ボリビア（多国籍）",
    BQ: "ボネール、シントユースタティウス、サバ",
    BA: "ボスニア　ヘルツェゴビナ",
    BW: "ボツワナ",
    BV: "ブーベ島",
    BR: "ブラジル",
    IO: "イギリス領インド洋海域",
    BN: "ブルネイダルサラーム",
    BG: "ブルガリア",
    BF: "ブルキナファソ",
    BI: "ブルンジ",
    CV: "カーボベルデ",
    KH: "カンボジア",
    CM: "カメルーン",
    CA: "カナダ",
    KY: "ケイマン諸島",
    CF: "中央アフリカ共和国",
    TD: "チャド",
    CL: "チリ",
    CN: "中国",
    CX: "クリスマス島",
    CC: "ココス（キーリング）諸島",
    CO: "コロンビア",
    KM: "コモロ",
    CG: "コンゴ",
    CD: "コンゴ（コンゴ民主共和国）",
    CK: "クック諸島",
    CR: "コスタリカ",
    CI: "コートジボアール",
    HR: "クロアチア",
    CU: "キューバ",
    CW: "キュラソー",
    CY: "キプロス",
    CZ: "チェコ",
    DK: "デンマーク",
    DJ: "ジブチ",
    DM: "ドミニカ",
    DO: "ドミニカ共和国",
    EC: "エクアドル",
    EG: "エジプト",
    SV: "エルサルバドル",
    GQ: "赤道ギニア",
    ER: "エリトリア",
    EE: "エストニア",
    SZ: "エスワティニ",
    ET: "エチオピア",
    FK: "フォークランド諸島（マルビナス）",
    FO: "フェロー諸島",
    FJ: "フィジー",
    FI: "フィンランド",
    FR: "フランス",
    GF: "フランス領ギニア",
    PF: "フランス領ポリネシア",
    TF: "フランス領南方地域",
    GA: "ガボン",
    GM: "ガンビア",
    GE: "ジョージア",
    DE: "ドイツ",
    GH: "ガーナ",
    GI: "ジブラルタル",
    GR: "ギリシャ",
    GL: "グリーンランド",
    GD: "グレナダ",
    GP: "グアドループ",
    GU: "グアム",
    GT: "グアテマラ",
    GG: "ガーンジー",
    GN: "ギニア",
    GW: "ギニアビサウ",
    GY: "ガイアナ",
    HT: "ハイチ",
    HM: "ハード島とマクドナルド諸島",
    VA: "バチカン市国",
    HN: "ホンジュラス",
    HK: "香港",
    HU: "ハンガリー",
    IS: "アイスランド",
    IN: "インド",
    ID: "インドネシア",
    IR: "イラン（イスラム共和国）",
    IQ: "イラク",
    IE: "アイルランド",
    IM: "マン",
    IL: "マン島",
    IT: "イタリア",
    JM: "ジャマイカ",
    JP: "日本",
    JE: "ジャージー",
    JO: "ヨルダン",
    KZ: "カザフスタン",
    KE: "ケニア",
    KI: "キリバス",
    KP: "北朝鮮",
    KR: "大韓民国",
    KW: "クウェート",
    KG: "キルギスタン",
    LA: "ラオス",
    LV: "ラトビア",
    LB: "レバノン",
    LS: "レソト",
    LR: "リベリア",
    LY: "リビア",
    LI: "リヒテンシュタイン",
    LT: "リトアニア",
    LU: "ルクセンブルク",
    MO: "マカオ",
    MK: "マケドニア（旧ユーゴスラビア）",
    MG: "マダガスカル",
    MW: "マラウイ",
    MY: "マレーシア",
    MV: "モルディブ",
    ML: "マリ",
    MT: "マルタ",
    MH: "マーシャル諸島",
    MQ: "マルティニーク",
    MR: "モーリタニア",
    MU: "モーリシャス",
    YT: "マヨット",
    MX: "メキシコ",
    FM: "ミクロネシア連邦",
    MD: "モルドバ共和国",
    MC: "モナコ",
    MN: "モンゴル",
    ME: "モンテネグロ",
    MS: "モントセラト",
    MA: "モロッコ",
    MZ: "モザンビーク",
    MM: "ミャンマー",
    NA: "ナミビア",
    NR: "ナウル",
    NP: "ネパール",
    NL: "オランダ",
    NC: "ニューカレドニア",
    NZ: "ニュージランド",
    NI: "ニカラグア",
    NE: "ニジェール",
    NG: "ナイジェリア",
    NU: "ニウエ",
    NF: "ノーフォーク島",
    MP: "北マリアナ諸島",
    NO: "ノルウェイ",
    OM: "オマーン",
    PK: "パキスタン",
    PW: "パラオ",
    PS: "パレスチナ",
    PA: "パナマ",
    PG: "パプアニューギニア",
    PY: "パラグアイ",
    PE: "ペルー",
    PH: "フィリピン",
    PN: "ピトケアン",
    PL: "ポーランド",
    PT: "ポルトガル",
    PR: "プエルトリコ",
    QA: "カタール",
    RE: "レユニオン",
    RO: "ルーマニア",
    RU: "ロシア連邦",
    RW: "ルワンダ",
    BL: "サンバルテルミー",
    SH: "セントヘレナ、アセンション、トリスタンダクーニャ",
    KN: "セントクリストファーネイビス",
    LC: "セントルシア",
    MF: "サンマルタン",
    PM: "サンピエール島とミクロン島",
    VC: "セントビンセントおよびグレナディーン諸島",
    WS: "サモア",
    SM: "サンマリノ",
    ST: "サントメプリンシペ",
    SA: "サウジアラビア",
    SN: "セネガル",
    RS: "セルビア",
    SC: "セイシェル",
    SL: "シエラレオネ",
    SG: "シンガポール",
    SX: "シントマールテン",
    SK: "スロバキア",
    SI: "スロベニア",
    SB: "ソロモン諸島",
    SO: "ソマリア",
    ZA: "南アフリカ",
    GS: "サウスジョージア島とサウスサンドイッチ諸島",
    SS: "南スーダン",
    ES: "スペイン",
    LK: "スリランカ",
    SD: "スーダン",
    SR: "スリナム",
    SJ: "スバールバル諸島およびヤンマイエン",
    SE: "スウェーデン",
    CH: "スイス",
    SY: "シリアアラブ共和国",
    TW: "台湾",
    TJ: "タジキスタン",
    TZ: "タンザニア連邦共和国",
    TH: "タイ王国",
    TL: "東ティモール",
    TG: "トーゴ",
    TK: "トケラウ",
    TO: "トンガ",
    TT: "トリニダード・トバゴ",
    TN: "チュニジア",
    TR: "トルコ",
    TM: "トルクメニスタン",
    TC: "タークスカイコス諸島",
    TV: "ツバル",
    UG: "ウガンダ",
    UA: "ウクライナ",
    AE: "アラブ首長国連邦",
    GB: "グレートブリテン及び北アイルランド連合王国",
    US: "アメリカ合衆国",
    UM: "合衆国領有小離島",
    UY: "ウルグアイ",
    UZ: "ウズベキスタン",
    VU: "バヌアツ",
    VE: "ベネズエラ",
    VN: "ベトナム",
    VG: "イギリス領バージン諸島",
    VI: "アメリカ領バージン諸島",
    WF: "ウォリスフツナ",
    EH: "西サハラ",
    YE: "イエメン",
    ZM: "ザンビア",
    ZW: "ジンバブエ",
  },
  wantEmail:
    "このQRコードのコピーを自分のメールアドレスに送信する場合は、以下にメールアドレスを入力してください。",
  keepOpen:
    "それ以外の場合は、デバイスでこのページを開いたままにしてください。",
  showCode:
    "電子税関申告書を作成いただきありがとうございます。 以下に表示されているQRコードをグアム税関職員に提示してください。",
  QREmailSubject: "グアムに入国するためのQRコード",
  hasErrors: "フォームに記入したことを確認してください",
  NonLatinCharacters: "次の文字は英語ではありません：",
  errorOccured: "エラーが発生しました。もう一度やり直してください。",
  emailSent: "電子メールを正常に送信",
};

export default jp_strings;
